import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useSolutionsProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '@grandvisionhq/state';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import { useDeliveryIntervalOptions } from '../../components/DeliveryIntervalSelect/use-delivery-interval-options.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { getActions } from './actions.js';
import { getInitialState } from './get-initial-state.js';
import { reducer } from './reducer.js';
import { selectors } from './selectors.js';

const DEFAULT_SOLUTION_MAX_QUANTITY = 5;
const SolutionsEcommContext = /*#__PURE__*/ React.createContext({});
const useSolutionsEcommContext = ()=>React.useContext(SolutionsEcommContext)
;
const SolutionsEcommProvider = ({ children , maxOrderableQuantity  })=>{
    const { activeVariant , selectedPurchaseType  } = useSolutionsProductData();
    const { availableSubscriptionIntervals  } = activeVariant;
    const { singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval: null,
        availableSubscriptionIntervals
    });
    const getInitialStateProps = {
        purchaseType: selectedPurchaseType,
        defaultDeliveryInterval: singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.value
    };
    const [state, dispatch] = React.useReducer(reducer, getInitialStateProps, getInitialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    // Reset validation errors when the selected purchase type changes
    React.useEffect(()=>{
        actions.updatePurchaseType(selectedPurchaseType);
    }, [
        actions,
        selectedPurchaseType
    ]);
    const value = React.useMemo(()=>({
            actions,
            state,
            selectors,
            maxOrderableQuantity: maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : DEFAULT_SOLUTION_MAX_QUANTITY
        })
    , [
        actions,
        maxOrderableQuantity,
        state
    ]);
    return /*#__PURE__*/ React.createElement(SolutionsEcommContext.Provider, {
        value: value
    }, children);
};

export { SolutionsEcommContext, SolutionsEcommProvider, useSolutionsEcommContext };
//# sourceMappingURL=SolutionsEcommContext.js.map
